export enum ApprovalActions {
    Approve = 'Approve',
    Deny = 'Deny',
    ForceApprove = 'Force Approve',
    ForceDeny = 'Force Deny',
}
